import { CostCentreService } from '../model/cost-centre.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { CostCentre } from 'assets-model';
import { Observable } from 'rxjs';


export class CostCentreDataSource extends CrudDataSource<CostCentre> {

  constructor(private service: CostCentreService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<CostCentre>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


